import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const [resendLock, setResendLock] = useState(0);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/v62/forgot-password`, { email });
      setSent(data.message);
      // Disable resend for 60s
      let t = 60;
      setResendLock(t);
      const iv = setInterval(() => {
        t -= 1;
        setResendLock(t);
        if (t <= 0) clearInterval(iv);
      }, 1000);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--cw-bg)" }}>
      <div className="cw-card p-8 w-full max-w-md" data-testid="forgot-password-page">
        <h1 className="cw-h2">Forgot password?</h1>
        <p className="text-sm text-[var(--cw-muted)] mt-2">
          Enter your email and we'll send you a link to reset your password.
        </p>
        <input value={email} onChange={(e) => setEmail(e.target.value)}
          type="email" placeholder="Email"
          className="w-full h-10 px-3 mt-4 rounded-md border text-sm"
          style={{ borderColor: "var(--cw-border)" }}
          data-testid="forgot-email-input" />
        {sent && (
          <div className="text-xs text-[#1F6E3A] mt-3" data-testid="forgot-success">
            {sent}
          </div>
        )}
        <div className="mt-5 flex justify-between items-center">
          <button onClick={() => nav("/login")} className="cw-btn-ghost text-xs"
            data-testid="forgot-back-to-signin">Back to sign in</button>
          <button onClick={submit} disabled={busy || resendLock > 0 || !email}
            className="cw-btn-primary text-sm inline-flex items-center gap-1 disabled:opacity-50"
            data-testid="forgot-submit">
            {resendLock > 0 ? `Resend in ${resendLock}s` : (busy ? "Sending…" : "Send reset link")}
          </button>
        </div>
      </div>
    </div>
  );
}
